import { render, staticRenderFns } from "./NoticeCard.vue?vue&type=template&id=52337f20&scoped=true&"
import script from "./NoticeCard.vue?vue&type=script&lang=js&"
export * from "./NoticeCard.vue?vue&type=script&lang=js&"
import style0 from "./NoticeCard.vue?vue&type=style&index=0&id=52337f20&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52337f20",
  null
  
)

export default component.exports